<template>
  <div v-wechat-title="titleTop">
    <div>
      <TopBar v-if="!isHorizontal" id="topBar" :back-level="10000" :pagetitle="title" :back-url="backurl" style="border-bottom: 1px solid #999;" />
    </div>
    <div v-if="support" class="allBack" />
    <div v-if="!support">
      不支持横屏显示，如需横屏观看，请点击右上角...选择用浏览器打开。
    </div>
    <div v-if="support" class="videoRect" :style="{width: rectWidth,heigth: rectHeigth, padding: '0 '+rectLeft}">
      <video-player
        ref="videoPlayer"
        class="video-player-box"
        :options="playerOptions"
        :playsinline="true"
        :webkit-playsinline="true"
        :x5-playsinline="true"
        custom-event-name="customstatechangedeventname"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @statechanged="playerStateChanged($event)"
        @timeupdate="onPlayerTimeupdate($event)"
        @ready="playerReadied"
      />
    </div>
    <div v-if="!isHorizontal" class="QARectList" :style="'top:'+qaRectTop+';height:'+qaRectHeight">
      <div v-for="item in qaList" :key="item.eCourseUnitQaId" class="rect">
        <div class="q">Q:{{ item.question }}?</div>
        <div class="a" :style="'color:'+GetDiveMainBack()">A:{{ item.answer }}</div>
      </div>
    </div>

    <van-popup
      v-if="questionData"
      v-model="showQuestion"
      :close-on-click-overlay="false"
      class="questionRect"
    >
      <div class="title">随堂问答</div>
      <div class="asker">{{ questionData.question }}{{ questionData.isMultiple?'[多选]':'' }}</div>
      <van-radio-group v-if="!questionData.isMultiple" v-model="questionSelect" :checked-color="GetDiveMainBack()">
        <van-radio v-for="(answer,index) in questionData.answer" :key="index" :name="index+''" class="answer">{{ answer }}</van-radio>
      </van-radio-group>
      <van-checkbox-group v-if="questionData.isMultiple" v-model="questionSelect" :checked-color="GetDiveMainBack()">
        <van-checkbox v-for="(answer,index) in questionData.answer" :key="index" :name="index+''" class="answer">{{ answer }}</van-checkbox>
      </van-checkbox-group>
      <div v-if="showQuestionAnalysis" class="analysis"><b>题目解析:</b>{{ questionData.analysis }}</div>
      <van-button v-if="!answerLoading" type="primary" class="buttonRect" round size="small" :color="GetDiveMainBack()" @click="onSubjectAnswer">提交答案</van-button>
      <van-button v-if="answerLoading && answerLoadingText" type="danger" icon="cross" class="buttonRect" round size="small">{{ answerLoadingText }}</van-button>
      <van-button v-if="answerLoading && !answerLoadingText" type="primary" icon="success" class="buttonRect" round size="small">回答正确</van-button>
    </van-popup>
    <van-popup
      v-if="data"
      v-model="showFinish"
      :close-on-click-overlay="false"
      class="finishRect"
    >
      <div class="title">完成章节学习</div>
      <div v-if="data.next" class="buttonRect">
        <van-button type="primary" class="button" round size="small" :color="GetColorSecondary()" @click="onBackMenu">返回目录</van-button>
        <van-button type="primary" class="button" round size="small" :color="GetDiveMainBack()" @click="onNextUnit">下一节:{{ data.next.nextName }}</van-button>
      </div>
      <div v-if="!data.next" class="buttonRect">
        <van-button type="primary" class="buttonOne" round size="small" :color="GetColorSecondary()" @click="onBackMenu">返回目录</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import 'video.js/dist/video-js.css'
import { Popup, RadioGroup, Checkbox, CheckboxGroup, Radio, Button, Toast } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import { videoPlayer } from 'vue-video-player'
const detector = require('detector')
export default {
  components: {
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    TopBar,
    videoPlayer
  },
  data() {
    return {
      titleTop: '',
      title: '在线学习',
      backurl: '/dive',
      rectWidth: '100vw',
      rectHeigth: '56vw',
      id: undefined,
      studentId: undefined,
      support: true,
      isAndroidWechat: false,
      isHorizontal: false, // 是否横屏
      maxCanCurrent: 0, // 允许的最大拖动进度
      lastCurrent: 0, // 最后的拖动进度
      postCurrent: undefined, // 自动上传进度条
      postTimespace: 0, // 自动上传进度 累计时间
      aspectRatio: undefined, // 视频高宽16:x
      rectLeft: '0',
      screenWidth: 0,
      screenHeight: 0,
      qaRectTop: 0,
      qaRectHeight: 0,
      data: undefined,
      qaList: [],
      playerOptions: {
        // videojs options
        muted: true,
        autoplay: false,
        language: 'zh-CN',
        aspectRatio: '16:9',
        checkTime: 50, // 测试用
        playbackRates: [1.0, 5.0, 10.0], // 测试用
        // checkTime :5,
        // playbackRates: [0.7, 1.0, 1.2, 1.5],

        // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        width: document.documentElement.clientWidth,
        sources: [],
        // sources: [{
        //   type: 'video/mp4',
        //   // src: '/dive/video.mp4'
        //   src: 'http://cooldivefile.gywzjs.com/video3.mp4'
        // }],
        poster: '',
        controlBar: {
          fullscreenToggle: false // 全屏按钮
        }
      },

      showQuestion: false,
      questionSelect: undefined,
      showQuestionAnalysis: false,
      answerLoading: false,
      answerLoadingText: '错误',
      questionData: {
        startTime: new Date(),
        answerTick: 0,
        trueAnswer: [0, 1],
        isMultiple: true,
        question: '想不想去学潜水?想不想去学潜水?想不想去学潜水?想不想去学潜水?想不想去学潜水?想不想去学潜水?',
        analysis: '必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!必须想，一定要去!',
        answer: [
          '必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必须想必',
          '一定要去',
          '一般般',
          '不想'
        ]
      },
      showFinish: false
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('resize', this.renderResize, false)
  },
  mounted() {
    // 监听resize方法
    window.addEventListener('resize', this.renderResize, false)
    console.log('this is current player instance object', this.player)
    this.onChangeSize()
  },
  created() {
    this.titleTop = GetDiveTitle()
    this.isAndroidWechat = detector.os.name === 'android' && detector.browser.name === 'micromessenger'
    this.id = this.$route.params.id
    this.studentId = getUrlKey('student')
    this.qaList = []
    this.init(() => {
      this.loadQaList()
    })
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      this.data = undefined
      this.showFinish = false
      this.maxCanCurrent = 0
      this.lastCurrent = 0
      this.postCurrent = undefined
      this.postTimespace = 0
      this.qaList = []
      request({
        url: '/DiveLearn/getVideoUnit',
        method: 'post',
        data: {
          studentId: this.studentId,
          unitId: this.id
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.unitName
        this.backurl = '/divetrip/eLearn/' + this.studentId
        console.log('当前最大长度', this.data.videoMaxLen)
        this.maxCanCurrent = this.data.videoMaxLen
        this.lastCurrent = this.data.videoMaxLen

        this.playerOptions.sources = []
        this.playerOptions.sources.push({
          type: 'video/mp4',
          src: this.data.videoUrl
        })
        this.playerOptions.poster = this.data.videoPic
        if (callback) {
          callback()
        }
      })
    },
    loadQaList(unitId) {
      request({
        url: '/DiveLearn/getVideoQaList',
        method: 'post',
        params: {
          unitId: this.data.eCourseUnitId
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.qaList = response.data
      })
    },
    onBackMenu() {
      this.$router.push('/divetrip/eLearn/' + this.studentId)
    },
    onNextUnit() {
      switch (this.data.next.nextType) {
        case 'Video':
          this.$router.push('/divetrip/eVideo/' + this.data.next.nextId + '?student=' + this.studentId)
          this.id = this.data.next.nextId
          this.init(() => {
            this.loadQaList()
          })
          break
        case 'Test':
          this.$router.push('/divetrip/exam?examId=' + this.data.next.examId + '&studentId=' + this.studentId)
          break
        case 'Exam':
          this.$router.push('/divetrip/eLearn/' + this.studentId)
          break
        case 'Subscribe':break
      }
    },
    renderResize() {
      this.onChangeSize()
      // 做页面适配
      // 注意：renderResize方法执行时虚拟dom尚未渲染挂载，如果要操作vue实例，最好在this.$nextTick()里进行。
    },
    onChangeSize() {
      this.screenWidth = document.documentElement.clientWidth
      this.screenHeight = document.documentElement.clientHeight
      this.isHorizontal = this.screenWidth > this.screenHeight
      if (this.isAndroidWechat && this.screenWidth > this.screenHeight) {
        this.support = false
        return
      } else {
        this.support = true
      }
      if (this.isAndroidWechat && !this.aspectRatio) {
        var height = document.documentElement.clientHeight - document.getElementById('topBar').clientHeight * 2
        this.aspectRatio = parseInt(height * 16 / document.documentElement.clientWidth - 1)
        this.playerOptions.aspectRatio = '16:' + this.aspectRatio
        // alert('cc:' + this.aspectRatio)
      }
      // this.playerOptions.width = this.screenWidth

      if (this.screenHeight / this.screenWidth < 0.5625) {
        if (this.isAndroidWechat) {
          console.log('a')
        } else {
          const maxWidth = this.screenHeight * 16 / 9
          const widthZoom = maxWidth / this.screenWidth
          this.rectWidth = (widthZoom * 100) + 'vw'
          this.rectHeigth = (widthZoom * 56) + 'vw'
          this.rectLeft = ((1 - widthZoom) * 0.5 * 100) + 'vw'
        }
      } else {
        this.rectWidth = '100vw'
        this.rectHeigth = '56vw'
        this.rectLeft = '0'

        if (this.isAndroidWechat) {
          var emptyRatio = (this.aspectRatio - 9) * 0.5
          var star = (emptyRatio + 9) / 16 * 100
          var qaHeight = emptyRatio / 16 * 100
          this.qaRectTop = 'calc(' + star + 'vw + 3.5em)'
          this.qaRectHeight = 'calc(' + qaHeight + 'vw - 2.1em)'
        } else {
          this.qaRectTop = 'calc(56vw + 3.5em)'
          this.qaRectHeight = 'calc(100vh - 56vw - 3.5em)'
        }
      }
    },
    // listen event
    onPlayerPlay(player) {
      console.log('player play!', player)
    },
    onPlayerPause(player) {
      console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      console.log('player Ended', player)
      this.maxCanCurrent = player.currentTime()
      this.onUploadProgress(player.currentTime(), true)
      this.showFinish = true
    },
    onPlayerTimeupdate(player) {
      if (this.data.isPass) {
        return
      }
      const tm = Math.floor(player.currentTime())
      console.log('player time:', player.currentTime())
      if (!this.OnCurrent(player.currentTime())) {
        return
      }
      this.onUploadProgress(player.currentTime(), false)
      for (var i = 0; i < this.data.testList.length; i++) {
        var item = this.data.testList[i]
        if (item.isAnswer) {
          continue
        }
        if (item.timeEndSecond) {
          if (!(item.timeBeginSecond <= tm && tm <= item.timeEndSecond)) {
            continue
          }
        } else {
          if (!(item.timeBeginSecond <= tm)) {
            continue
          }
        }
        this.questionData = item
        this.questionData.answerTick = 0
        this.onShowQuestion()
        return
      }
    },
    // /更新观看进度到服务器
    onUploadProgress(tm, isFinish) {
      if (!isFinish) {
        if (tm < this.maxCanCurrent) {
          return
        }
        if (!this.postCurrent) {
          this.postCurrent = tm
          return
        }
        if (this.postCurrent >= tm) {
          return
        }
        var span = tm - this.postCurrent
        this.postCurrent = tm
        this.postTimespace += span
        // console.log('onUploadProgress span:', span + ':' + this.postTimespace)
        if (this.postTimespace < 10) {
          return
        }
      }
      console.log('upload')
      this.postTimespace = 0
      var data = {
        second: tm,
        isPass: isFinish
      }
      console.log('this.data.unitProgressId', this.data.unitProgressId)
      if (this.data.unitProgressId) {
        data.unitProgressId = this.data.unitProgressId
      } else {
        data.studentId = this.studentId
        data.eCourseUnitId = this.data.eCourseUnitId
      }
      request({
        url: '/DiveLearn/updateVideoProgress',
        method: 'post',
        data: data
      }).then(response => {
        if (!response.success) {
          this.player.pause()
          Toast.fail(response.message)
          return
        }
        this.data.unitProgressId = response.data
      })
    },
    // 处理进度条允许拖拽
    OnCurrent(tm) {
      if (tm - 2 < this.lastCurrent) {
        this.lastCurrent = tm
        if (tm > this.maxCanCurrent) {
          this.maxCanCurrent = tm
        }
        return true
      }
      // lastCurrent
      console.log('MAX:' + this.maxCanCurrent + ' set:' + tm)
      if (tm > this.maxCanCurrent + this.checkTime) {
        Toast.fail('不能快进未播放部分!,请认真观看视频')
        this.player.currentTime(this.maxCanCurrent)
        return false
      }
      this.lastCurrent = tm
      return true
    },
    playerStateChanged(playerCurrentState) {
      console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied(player) {
      console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
      // player.play()
      if (this.maxCanCurrent > 0 && !this.data.isPass) {
        this.player.currentTime(this.maxCanCurrent)
        console.log(this.maxCanCurrent)
      }
    },
    // 显示问题
    onShowQuestion() {
      if (!this.questionData) {
        return
      }
      this.questionData.startTime = new Date()
      this.player.pause()
      this.showQuestion = true
      this.questionSelect = undefined
      this.showQuestionAnalysis = false
      this.answerLoading = false
    },
    onSubjectAnswerError(title) {
      this.answerLoadingText = title
      this.answerLoading = true
      setTimeout(() => {
        this.answerLoading = false
      }, 1500)
    },
    onSubjectAnswer() {
      if (this.questionData.isMultiple) {
        if (!this.questionSelect || this.questionSelect.length <= 1) {
          this.onSubjectAnswerError('请至少选择2个答案')
          return
        }
        if (this.questionSelect.length !== this.questionData.trueAnswer.length) {
          this.showQuestionAnalysis = true
          this.questionData.answerTick++
          this.onSubjectAnswerError('回答错误,请重试')
          return
        }
        this.questionSelect.sort(function(x, y) { return x > y ? 1 : -1 })
        // console.log('排序后的数组', this.questionSelect)
        // console.log('排序后的数组a:', this.questionSelect.toString())
        if (this.questionSelect.toString() !== this.questionData.trueAnswer.toString()) {
          this.showQuestionAnalysis = true
          this.questionData.answerTick++
          this.onSubjectAnswerError('回答错误,请重试')
          return
        }
      } else {
        if (this.questionSelect === undefined) {
          this.onSubjectAnswerError('请选择答案')
          return
        }
        console.log('this.questionSelect', this.questionSelect)
        console.log('this.questionData.trueAnswer', this.questionData.trueAnswer)
        if (this.questionSelect !== this.questionData.trueAnswer[0]) {
          this.showQuestionAnalysis = true
          this.onSubjectAnswerError('回答错误,请重试')
          this.questionData.answerTick++
          return
        }
      }
      var test = this.data.testList.filter(item => item.eCourseQuestionId === this.questionData.eCourseQuestionId)
      test[0].isAnswer = true
      this.answerLoading = true
      this.answerLoadingText = undefined
      request({
        url: '/DiveLearn/updateVideoTest',
        method: 'post',
        data: {
          studentId: this.studentId,
          eCourseQuestionId: this.questionData.eCourseQuestionId,
          answerTick: this.questionData.answerTick + 1,
          startTime: this.questionData.startTime
        }
      })
      var my = this
      setTimeout(() => {
        my.questionData = undefined
        my.showQuestionAnalysis = false
        my.showQuestion = false
        my.player.play()
      }, 1000)
    }
  }
}
</script>

<style scoped>
.videoRect{
  background-color:#000;
  left: 0;
  top: 0;
  /* left:calc(50vw - 40vh);
  top:calc(50vh - 40vw);
  width: 80vh;
  height: 80vw; */
  overflow: hidden;

  /* transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  filter:progid:DXImageTransform.Microsoft.BasicImage(Rotation=1);  */
}
.finishRect{
    width: calc(100vw - 2em);
  border-radius: 0.4em;
}
.finishRect .title{
  text-align: center;
  padding: 0.3em 0;
  border-bottom: 1px solid #f5f5f5;
}
.finishRect .buttonRect{
  padding: 1em 1em 1em 0;
}
.finishRect .buttonRect .button{
  width: calc(50% - 1em);
  margin-left:1em;
}
.finishRect .buttonRect .buttonOne{
  width: calc(100% - 1em);
  margin-left:1em;
}

.questionRect{
  width: calc(100vw - 2em);
  border-radius: 0.4em;
  overflow-y: scroll;
}
.questionRect .title{
  text-align: center;
  padding: 0.3em 0;
  border-bottom: 1px solid #f5f5f5;
}
.questionRect .asker{
  padding:0.5em 1em;
  font-size: 0.9em;
}

.questionRect .analysis
{
  font-size: 0.7em;
  color: #999;
  padding: 0.5em 1em;
}
.questionRect .answer{
  font-size: 0.8em;
   padding: 0.25em 1em;
}
.questionRect .buttonRect{
  width: 50%;
  left: 25%;
  margin-top: 0.5em;
  margin-bottom: 1em;
}

/* .rect{
   z-index: 1;
  position: fixed;
  left: 30%;
  top:0;
  width: 5em;
  height: 100%;
  background-color: rgba(255,0,0,0.5);
  z-index: 100;

} */
.allBack{
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #000;
  z-index: -1;
  position: absolute;
}
.QARectList{
  position: fixed;
  z-index: 100;
  color: #fff;
  left: 1em;
  right: 1em;
  top: 70vw;
  height: 60vw;
  overflow-y: scroll;
}
.QARectList .rect{
  border-bottom: 1px solid #333;
  padding-bottom: 1em;
  margin-bottom: 1em;
}
.QARectList .rect:first-child{
  margin-top: 0.5em;
}
.QARectList .rect:last-child
{
  border-bottom: none;
}
.QARectList .rect .q{
  font-size: 0.9em;
  color: #fff;
  margin-bottom: 0.5em;
}
.QARectList .rect .a{
font-size: 0.9em;
}
</style>
